import { AnyIfEmpty } from 'react-redux';
import { GET_VISITS_FAILURE, GET_VISITS_REQUEST, GET_VISITS_SUCCESS } from '../constants/visits.constants';

const initialState = {
    loading: false,
    data: [],
    error: '',
};

const appointmentReducer = (state = initialState, action: AnyIfEmpty<object>) => {
    switch (action.type) {
        case GET_VISITS_REQUEST:
            return {
                ...state,
                loading: true,
                // Clear data on new request to prevent showing stale data during tab switches
                data: [],
                error: '',
            };
        case 'GET_VISITS_CLEAR':
            return {
                ...state,
                loading: false, // Don't change loading state, just clear data
                data: [],
                error: '',
            };

        case GET_VISITS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: '',
            };
        case GET_VISITS_FAILURE:
            return {
                ...state,
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
};

export default appointmentReducer;
